"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "style", {
    enumerable: true,
    get: function() {
        return style;
    }
});
const _lit = require("lit");
const style = (0, _lit.css)`
  :host {
    position: relative;
    display: inline-block;
    background-color: var(--md-sys-color-background, 'white');
  }

  md-outlined-button {
    --md-outlined-button-container-shape: 4px;
  }
`;
